import { InfoModal } from "@newsela/angelou";

import AILunaTag from "@/components/AIComponents/AILunaTag/AILunaTag";
import {
  modalContentWrapperCss,
  modalRootCss,
  scrollableBodyCss,
} from "./ExportablesModal.styles";
import ExportablesModalBody from "./ExportablesModalBody";
import { useExportablesContext } from "./ExportablesContextProvider/useExportablesContext";
import ExportablesModalFooter from "./ExportablesModalFooter";

interface ExportablesBaseModalProps {
  isStudent: boolean;
}

const ExportablesBaseModal = ({ isStudent }: ExportablesBaseModalProps) => {
  const {
    handleModalClose,
    isInAssignGraphicOrganizersExperiment,
    isLoading,
    modalProps,
  } = useExportablesContext();

  const modalTitle =
    isStudent || isInAssignGraphicOrganizersExperiment
      ? "Graphic organizers"
      : "Generate graphic organizers";

  return (
    <InfoModal
      __cssFor={{
        root: modalRootCss,
        modalContentWrapper: modalContentWrapperCss,
        scrollableBody: scrollableBodyCss(isStudent),
      }}
      closeButtonProps={{
        dataProps: { "data-qa-selector": "close-exportables-modal-button" },
        onClick: handleModalClose,
      }}
      eyebrow={!isStudent && <AILunaTag />}
      isMobileTakeover
      labelId="exportables-modal"
      onBackgroundClick={handleModalClose}
      title={modalTitle}
      footer={!isLoading && <ExportablesModalFooter isStudent={isStudent} />}
      {...modalProps}
    >
      <ExportablesModalBody isStudent={isStudent} />
    </InfoModal>
  );
};

export default ExportablesBaseModal;
